import {merge, cloneDeep} from 'lodash';
import en from './locales/en.json';
import ru from './locales/ru.json';

export default {
    en,
    ru: merge(cloneDeep(en), ru)
}
